<div class="kitchen-container">
  <mat-toolbar color="primary" class="kitchen-toolbar">
    <span>Cocina</span>
    <span class="spacer"></span>
    <button
      mat-icon-button
      (click)="refreshOrders()"
      [disabled]="isLoading"
      matTooltip="Actualizar"
      class="refresh-btn"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  <div class="content">
    <ng-container *ngIf="isLoading; else content">
      <div class="loading">
        <mat-spinner diameter="24"></mat-spinner>
        <p>Cargando...</p>
      </div>
    </ng-container>

    <ng-template #content>
      <div *ngIf="itemsInPreparation.length === 0" class="empty-state">
        <mat-icon class="empty-icon">restaurant_menu</mat-icon>
        <h3>No hay pedidos</h3>
        <p>Los nuevos pedidos aparecerán aquí</p>
      </div>

      <div class="items-list">
        <div *ngFor="let item of itemsInPreparation" class="item-row">
          <div class="item-header">
            <span class="order-id">#{{ item.orderId | slice: 0 : 6 }}</span>
            <span
              class="time"
              [class.time-warning]="isTimeWarning(item.timeElapsed)"
              >{{ item.timeElapsed }}</span
            >
            <button
              mat-icon-button
              color="primary"
              (click)="markAsReady(item)"
              *ngIf="item.itemStatusSlug === 'sent'"
              class="action-button"
              matTooltip="Marcar como listo"
            >
              <mat-icon>check</mat-icon>
            </button>
          </div>

          <div class="item-content">
            <span class="quantity">{{ item.qty }}x</span>
            <span class="item-name">
              {{ item.name }}
              <span class="customer-name" *ngIf="item.customerName">
                {{ item.customerName }}
              </span>
            </span>
            <span class="price">{{
              item.price * item.qty | currency: "CLP" : "symbol" : "1.0-0"
            }}</span>
            <span
              class="status-badge"
              [class.status-sent]="item.itemStatusSlug === 'sent'"
              [class.status-preparation]="
                item.itemStatusSlug === 'in_preparation'
              "
            >
              {{ statusInitial(item) }}
            </span>
          </div>

          <div *ngIf="item.description" class="item-notes">
            <mat-icon class="note-icon" [matTooltip]="item.description"
              >info</mat-icon
            >
          </div>

          <div class="item-actions">
            <ui-button
              variant="primary"
              size="sm"
              (click)="markAsReady(item)"
              [disabled]="item.isMarking || item.itemStatusSlug !== 'sent'"
            >
              <ng-container *ngIf="!item.isMarking; else loadingTpl">Avanzar</ng-container>
            </ui-button>
            <ng-template #loadingTpl>
              <mat-icon class="spin">refresh</mat-icon>
            </ng-template>
            <ui-button
              variant="secondary"
              size="sm"
              (click)="openOrderPreviewForItem(item)"
            >
              Ver orden
            </ui-button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
